import { adminClient } from "./admin";

export const fetchInboundLog = async (limit = 100) =>
  (await adminClient().get(`/email-intake/log`, { params: { limit } })).data;

export const fetchLlmUsage = async () =>
  (await adminClient().get(`/admin/llm-usage`)).data;

export const scanStorePrefixMismatch = async () =>
  (await adminClient().get(`/admin/tools/store-prefix-mismatch`)).data;

export const reassignByStorePrefix = async (payload) =>
  (await adminClient().post(`/admin/tools/reassign-by-store-prefix`, payload)).data;

// Per-decision swatches (mirrors the materials-tab idiom).
export const INTAKE_DECISION_COLORS = {
  created:               { bg: "#D1FAE5", fg: "#064E3B", border: "#10B981", label: "Created" },
  threaded:              { bg: "#DBEAFE", fg: "#1E3A8A", border: "#3B82F6", label: "Threaded" },
  duplicate:             { bg: "#E7E5E4", fg: "#1C1917", border: "#A8A29E", label: "Duplicate" },
  discarded_no_sender:   { bg: "#FEE2E2", fg: "#991B1B", border: "#DC2626", label: "Discarded" },
};

export const INTAKE_PRIORITY_COLORS = {
  Critical: { bg: "#DC2626", fg: "#FFFFFF" },
  Rush:     { bg: "#F97316", fg: "#FFFFFF" },
  High:     { bg: "#F59E0B", fg: "#1C1917" },
  Normal:   { bg: "#E7E5E4", fg: "#1C1917" },
};
